import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import fetchOrder from "areas/order/hoc/fetch-order"
import HolidayMsg from "areas/order/holiday-msg"
import OrderNumber from "areas/order/order-number"
import { showHolidayRma } from "helpers/holiday"

import { FormContainer, FormWrapper, Text } from "../components"
import Heading from "../heading"

import OrderForm from "./order-form"

const Repair = ({ data }) => {
  const [orderData, setData] = useState(data)

  useEffect(() => {
    setData(data)
  }, [data])

  if (orderData && orderData.order) {
    return <OrderForm orderData={orderData} />
  } else {
    return (
      <FormContainer>
        <FormWrapper>
          <Heading rmaType="repair" />
          {showHolidayRma() && (
            <HolidayMsg style={{ borderColor: "#1ABBDA" }} />
          )}

          <Text>
            Complete this form to request a repair for your Jewl item(s). Your
            item(s) include a limited manufacturer&apos;s warranty. To learn
            more, please read our{" "}
            <Link data-lc="repair" to="/info/warranty-information">
              Warranty Policy
            </Link>
            .
          </Text>
          <br />
          <Text>
            If you require assistance, please contact customer service at{" "}
            <a
              className="nowrap"
              href={`tel:${sl.config.customer_service_toll_free}`}
            >
              {sl.config.customer_service_toll_free}
            </a>{" "}
            or{" "}
            <a
              className="nowrap"
              href={`mailto:${sl.config.customer_service_email}`}
            >
              {sl.config.customer_service_email}
            </a>{" "}
          </Text>
          <br />
          <Text>
            Please enter the following required information so we can help you.
          </Text>

          {orderData?.errors && (
            <Text color="error" mb={2} mt={2}>
              {orderData.errors[0]}
            </Text>
          )}
        </FormWrapper>
        <OrderNumber
          rmaType="repair"
          setData={setData}
          validatePath="/secure/api/v10/order/order_info_for_rma"
        />
      </FormContainer>
    )
  }
}

Repair.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(Repair)
